import { E_SHARE_TYPE, SHARE_TYPES } from '../constants';
import { TCalendarEvent } from './get-calendars-collection';

interface IShare {
  type: E_SHARE_TYPE;
  displayName: string;
  url: string;
}

export const getShareUrl = (
  event: TCalendarEvent,
  shareType: E_SHARE_TYPE
): string => {
  switch (shareType) {
    case E_SHARE_TYPE.FACEBOOK:
      return `https://www.facebook.com/sharer.php?${new URLSearchParams({
        u: event.url || '',
        quote: event.bodySanitized || '',
      })}`;
    case E_SHARE_TYPE.TELEGRAM:
      return `https://telegram.me/share/url?${new URLSearchParams({
        url: event.url || '',
        text: event.bodySanitized || '',
      })}`;
    case E_SHARE_TYPE.TWITTER:
      return `https://twitter.com/intent/tweet?${new URLSearchParams({
        url: event.url || '',
        text: event.bodySanitized || '',
      })}`;
    case E_SHARE_TYPE.LINKEDIN:
      return `https://www.linkedin.com/shareArticle?${new URLSearchParams({
        url: event.url || '',
        text: event.bodySanitized || '',
        mini: 'true',
      })}`;
  }
};

export const getShareCollection = (
  calendarEvent: TCalendarEvent,
  defaultUrl?: string
): IShare[] => {
  const shareCollection = SHARE_TYPES.map((calendar) => {
    const url = getShareUrl(
      { ...calendarEvent, url: calendarEvent.url || defaultUrl },
      calendar.type
    );
    return { ...calendar, url };
  });
  return shareCollection;
};
